import React, { useEffect, useRef, useState } from "react";
import Language from "./Lang";
import { NavLink } from "react-router-dom";
import Loader from "../Popup/Loader";
import { produrl } from "../utils/helper";

const ReferList = () => {
  const [loading, setLoading] = useState(false);
  const [index, setIndex] = useState("");
  const [resultData, setResultData] = useState([]);
  const [loadmore, setLoadmore] = useState(false);
  const [freshlang, setFreshlang] = useState("");
  const [type, setType] = useState("constituency");
  // useEffect(() => {
  //   getReferralFetch();
  // }, []);

  const getReferralFetch = async () => {
    const url = `${produrl}api/v1/pm/referrals?offset_time=&page_size=10${
      type == "constituency" ? "&is_loading_for_same_ac=true" : ""
    }`;
    const options = {
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("acesss"),
      },
    };

    try {
      const response = await fetch(url, options);
      const data = await response.json();
      if (data?.data?.length > 9) {
        setIndex(data.data[data.data.length - 1].offset_time || "");
        // setResultData([...resultData, ...data.data]);
        setResultData(data.data);
        setLoadmore(() => true);
      } else {
        setLoadmore(() => false);
        // setResultData([...resultData, ...data.data]);
        setResultData(data.data);
      }
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getReferralFetch();
  }, [type]);

  useEffect(() => {
    onScroll();
  }, [resultData, loadmore]);

  const onScroll = () => {
    window.onscroll = null;
    window.onscroll = () => {
      if (
        window.pageYOffset >
          document.documentElement.scrollHeight - window.innerHeight - 1 &&
        loadmore
      ) {
        if (loadmore) {
          loadMoreData();
        }
      }
    };
  };

  const loadMoreData = async () => {
    if (!loadmore) {
      return false;
    }
    setLoading(true);
    const url = `${produrl}api/v1/pm/referrals?offset_time=${index}&page_size=10${
      type == "constituency" ? "&is_loading_for_same_ac=true" : ""
    }`;
    const options = {
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("acesss"),
      },
    };

    try {
      const response = await fetch(url, options);
      const data = await response.json();
      if (data?.data?.length > 9) {
        setIndex(data.data[data.data.length - 1].offset_time || "");
        setResultData([...resultData, ...data.data]);
        setLoadmore(() => true);
      } else {
        setLoadmore(() => false);
        setResultData([...resultData, ...data.data]);
      }
      console.log(data);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const setLanguval = (lang) => {
    setFreshlang(lang);
  };

  const setFilter = (filterType) => {
    setType(filterType);
  };
  return (
    <>
      {loading && <Loader />}
      <div className="faqbg_wid">
        <div className="faq_bg">
          <div className="lang_headerbg">
            <div className="member_container">
              <div className="lang_header">
                <div className="janta_part_flex">
                  <img
                    src="/assets/images/bjplogonew.png"
                    className="bjplogo"
                    alt="BJPL Logo"
                  />
                  <h6>Bharatiya Janata Party</h6>
                </div>
                <Language freshlang={setLanguval} />
              </div>
            </div>
          </div>

          <div className="member_container">
            <ul className="refergoback">
              <li>
                <NavLink to={"/refer" + window.location.search}>
                  <img src="/assets/images/backarrow2.png" alt="" /> Go back
                </NavLink>
              </li>
            </ul>

            <ul className="refmen_count">
              <li>
                <h5>Referred Member</h5>
              </li>
              <li>
                <h6>
                  Total Member :{" "}
                  <span>{localStorage.getItem("referral_count")}</span>
                </h6>
              </li>
              {/* <li>
                <div className="dropdown drop_cust">
                  <button
                    type="button"
                    className="btn_drop btn btn-primary dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    <i className="bi bi-funnel"></i>
                  </button>
                  <ul className="dropdown-menu dropmenu_cust">
                    <li
                      onClick={() => {
                        setFilter("constituency");
                      }}
                    >
                      <a className="dropdown-item" href="#">
                        From my constituency
                      </a>
                    </li>
                    <li
                     
                    >
                      <a className="dropdown-item" href="#">
                        All
                      </a>
                    </li>
                  </ul>
                </div>
              </li> */}
            </ul>

            <ul className="allrefer_tab">
              <li>
                <a
                  className={type == "constituency" ? "active" : ""}
                  onClick={() => {
                    setFilter("constituency");
                  }}
                >
                  <span className="const_text">From My Constituency</span>
                  <span className="divider"></span>
                </a>
              </li>

              <li>
                <a
                  className={type == "all" ? "active" : ""}
                  onClick={() => {
                    setFilter("all");
                  }}
                >
                  <span className="const_text">All</span>
                  <span className="divider"></span>
                </a>
              </li>
            </ul>

            {/* <h6 className="tota_ref_count">
              Total Member :{" "}
              <span>{localStorage.getItem("referral_count")}</span>
            </h6> */}

            {resultData &&
              resultData.length > 0 &&
              resultData.map((item) => {
                console.log("hello", item);
                // if (type) {
                //   if (
                //     type == "constituency" &&
                //     localStorage.getItem("constituency_name") != item.ac_name
                //   ) {
                //     return false;
                //   }
                // }
                return (
                  <>
                    <ul className="ref_list_member">
                      <li>
                        <img src="/assets/images/userdefault.jpg" alt="" />
                      </li>
                      <li className="refpadlist">
                        <h4>{item.name}</h4>
                        {/* <h5>{item.phone_number}</h5>
                        <h6>
                          Date of Joining : <span>{item.date_of_joining}</span>
                        </h6> */}
                        <div className="boothnum_flex">
                          <div className="booth_wid">
                            <h5>Phone number :</h5>
                            <h6>
                              <span>{item.phone_number}</span>
                            </h6>
                          </div>
                          <div className="booth_wid">
                            <h5>Assembly Name :</h5>
                            <h6>
                              <span>{item.ac_name}</span>
                            </h6>
                          </div>
                          {item.masked_mandal_name && (
                            <div className="booth_wid">
                              <h5>Mandal :</h5>

                              <h6>
                                <span>{item.masked_mandal_name}</span>
                              </h6>
                            </div>
                          )}

                          <div className="booth_wid">
                            <h5>Membership ID :</h5>
                            <h6>
                              <span>{item.masked_membership_id}</span>
                            </h6>
                          </div>

                          <div className="booth_wid">
                            <h5>Date of Joining :</h5>
                            <h6>
                              <span>{item.date_of_joining}</span>
                            </h6>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </>
                );
              })}
          </div>
        </div>
      </div>
    </>
  );
};

export default ReferList;
